module.exports = __webpack_public_path__ + "assets/img/step1.2bca7913.png";